import {client} from '@core/GraphQLProvider';
import {NewsletterSignup, OpalescenceSignUp} from './query.graphql';

if ( process.env.MOCK_API == 1 ) {
    require( './mocks' );
}

(process.env.MOCK_API == 1) && require( './mocks' );

const NewsletterService = {
    async subscribe ( emailAddress ) {
        const resp = await client.mutate( {
            mutation: NewsletterSignup,
            variables: {emailAddress}
        } );

        return resp.data.newsletterSignup;
    },

    async opalSubscribe( {input} ) {
        const resp = await client.mutate( {
            mutation: OpalescenceSignUp,
            variables: {input}
        } );

        return resp.data.opalescenceInTheLoopSignup
    }
};

export default NewsletterService;
